<template>
    <v-list>
        <v-text-field
            v-if="showSearch"
            v-model="search"
            :loading="searchLoading"
            label="Search Messages"
            append-icon="search"
            outlined
            rounded
            dense
            hide-details
            clearable
            :autofocus="!!searching"
            class="py-1 chat-search"
            @input="setSearchTimer()"
            @click:clear="search = ''"
        ></v-text-field>

        <v-list v-if="showLoading" class="w-full">
            <v-skeleton-loader
                class="w-full"
                type="list-item-avatar-three-line@6"
        /></v-list>

        <!--<v-list-item-group
            v-if="search.length && !showLoading"
            :class="{ 'conversation-scroll': $vuetify.breakpoint.mdAndUp }"
            class="py-4"
        >
            <v-list-item
                v-for="item in results"
                :key="item.message_id"
                :value="item.id"
                three-line
                class="soli-round conversation-items"
                @click="$emit('input', item)"
            >
                <ConversationPreview :item="item" />
            </v-list-item>
        </v-list-item-group>-->

        <v-list-item-group
            v-if="!showLoading"
            ref="conversationList"
            :value="value?.id ?? null"
            :class="{
                'conversation-scroll':
                    $vuetify.breakpoint.mdAndUp && allConversations.length,
            }"
            class="py-4"
        >
            <v-list-item class="px-6" v-if="!allConversations.length">
                <v-list-item-title class="soli-grey"
                    >No Conversations Found</v-list-item-title
                >
            </v-list-item>
            <!--<v-list-item v-if="nextLoading" three-line>
                <v-skeleton-loader
                    class="w-full"
                    type="list-item-avatar-three-line"
            /></v-list-item>-->
            <div
                v-if="showViewLatest"
                class="flex shrink items-center w-full justify-center mb-4 sticky z-10 top-0"
            >
                <v-btn small rounded color="primary" @click="viewLatest()"
                    >View Latest</v-btn
                >
            </div>
            <v-list-item
                v-for="item in allConversations"
                :id="`conversation-${item.id}`"
                :key="item.id"
                :value="item.id"
                three-line
                class="soli-round conversation-items"
                @click="handleSelect(item)"
            >
                <ConversationPreview
                    :item="item"
                    :selected="item.id == value?.id"
                />
                <v-menu offset-y left
                    ><template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on" color="dark"
                            ><v-icon small>more_vert</v-icon></v-btn
                        >
                    </template>
                    <v-list>
                        <v-list-item @click="markUnread({ conversation: item })"
                            >Mark Unread
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>
            <v-list-item v-if="previousLoading" three-line>
                <v-skeleton-loader
                    class="w-full"
                    type="list-item-avatar-three-line"
            /></v-list-item>
            <div
                id="bottom-anchor"
                v-intersect="{
                    root: '.conversation-scroll',
                    handler: bottomVisible,
                    options: { rootMargin: '100px', threshold: 0 },
                }"
            />
        </v-list-item-group>
    </v-list>
</template>

<script>
import axios from "axios";
import ConversationPreview from "./ConversationPreview.vue";

export default {
    props: {
        index: {
            type: Object,
            default: () => ({ conversations: [] }),
        },
        value: {
            type: Object,
            default: () => {},
        },
        thread: {
            type: Object,
            default: () => ({}),
        },
        // Used to determine if the conversation is in the inbox or not
        showSearch: {
            type: Boolean,
            default: false,
        },
        crmMode: {
            type: Boolean,
            default: false,
        },
        searching: {
            type: String,
            default: "",
        },
    },
    data: function () {
        return {
            search: this.searching,
            results: [],
            searchLoading: false,
            searchTimeout: null,
            selecting: false,
            previousConversations: [],
            previousLoading: false,
            nextConversations: [],
            nextLoading: false,
            //moreNextConversations: !!this.value?.id,
            morePreviousConversations: true,
            scrolling: false,
            currentCursor: this.index?.cursor ?? null,
            nextCursor: this.index?.nextCursor ?? null,
            initialIndex: this.index?.conversations ?? [],
            allConversations: this.index?.conversations ?? [],
        };
    },
    components: { ConversationPreview },
    methods: {
        searchMessages() {
            this.$emit("input", null);

            this.$inertia.get(
                "/inbox",
                {
                    search: this.search,
                },
                {
                    only: ["index", "searching"],
                    preserveState: true,
                    preserveScroll: true,
                    onFinish: () => {
                        this.searchLoading = false;
                    },
                }
            );
        },
        setSearchTimer() {
            if (!this.search) this.search = "";
            if (!this.search.length) {
                this.results = [];
                this.$inertia.get(
                    "/inbox",
                    {},
                    {
                        preserveState: true,
                        preserveScroll: true,
                        only: ["index", "searching"],
                    }
                );
                return;
            }

            this.searchLoading = true;
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.searchMessages();
            }, 750);
        },
        clearSearchTimer() {
            clearTimeout(this.searchTimeout);
            this.searchLoading = false;
        },
        /**
         * Delay selection to offset modal transition on mobile, allows for proper loading indicator
         * @param item
         */
        handleSelect(item) {
            this.selecting = true;
            this.$emit("input", item);
            setTimeout(() => {
                this.selecting = false;
            }, 300);
        },
        markUnread({ conversation, messageId }) {
            axios
                .put(
                    `/conversation-user/${
                        conversation.conversation_user.id
                    }/mark-unread${messageId ? "/" + messageId : ""}`
                )
                .then(() => {
                    this.$inertia.reload({
                        data: {
                            w: 0,
                        },
                        only: [
                            "unreadMessageCount",
                            "conversation",
                            /*"messages",*/
                            "index",
                            "searching",
                        ],
                    });
                });
        },
        bottomVisible(entries, observer) {
            //console.log("bottomVisible", entries[0].isIntersecting);
            if (!entries[0].isIntersecting) return;
            this.loadPrevious();
        },
        scrollToConversation(conversationId, block = "start") {
            if (!conversationId) return;
            this.scrolling = true;

            setTimeout(() => {
                document
                    .getElementById(`conversation-${conversationId}`)
                    .scrollIntoView({
                        behavior: "instant",
                        block: block,
                    });
                this.scrolling = false;
            }, 25);
        },
        viewLatest() {
            this.$inertia.get(
                route("conversation.show"),
                {},
                {
                    preserveState: false,
                }
            );
        },
    },
    computed: {
        showViewLatest() {
            return !this.index.latestConversations;
        },
        showLoading() {
            if (this.searchLoading) return true;
            if (this.selecting) return false;
            return this.$root.loading && this.$vuetify.breakpoint.smAndDown;
        },
        previousPage() {
            //return this.index.nextPageUrl;
            if (!this.allConversations.length) return null;
            /*return `/conversations/${
                this.allConversations[this.lastConversation].id
            }/check-previous${this.value ? "/" + this.value.id : ""}`;*/
            return `/conversations/${
                this.allConversations[this.lastConversation].id
            }/check-previous?cursor=${this.nextCursor}`;
        },
        /*nextPage() {
            if (!this.allConversations.length) return null;
            return `/conversations/${this.allConversations[0].id}/check-next${
                this.value ? "/" + this.value.id : ""
            }`;
        },*/
        lastConversation() {
            return this.allConversations.length - 1;
        },
    },
    created() {
        this.loadPrevious = this.throttle(() => {
            if (!this.morePreviousConversations) return;
            if (this.initialIndex.length < 10) return; // match server pagination to avoid unnecessary calls
            if (!this.previousPage) return;
            if (this.showLoading) return;
            if (this.scrolling) return;
            if (this.previousLoading) return;

            this.previousLoading = true;

            /*this.$inertia.get(
                this.previousPage,
                {},
                {
                    preserveState: true,
                    preserveScroll: true,
                }
            );*/

            axios.get(this.previousPage).then((resp) => {
                const map = {};
                this.allConversations
                    .concat(resp.data.conversations)
                    .forEach((conv) => {
                        map[conv.id] = conv;
                    });
                this.allConversations = Object.values(map);
                this.currentCursor = resp.data.currentCursor;
                this.nextCursor = resp.data.nextCursor;
                this.previousLoading = false;
                if (!resp.data.moreConversations) {
                    this.morePreviousConversations = false;
                }
            });
        });

        /*this.loadNext = this.throttle(() => {
            if (!this.moreNextConversations) return;
            if (this.index.length < 10) return; // match server pagination to avoid unnecessary calls
            if (!this.nextPage) return;
            if (this.showLoading) return;
            if (this.scrolling) return;

            this.nextLoading = true;

            axios.get(this.nextPage).then((resp) => {
                this.nextConversations = [
                    ...new Set([...this.nextConversations, ...resp.data.index]),
                ];
                this.nextLoading = false;
                this.moreNextConversations = false;
            });
        });*/
    },
    beforeDestroy() {
        this.loadPrevious = null;
    },
    watch: {
        "index.conversations": {
            handler(newConversations) {
                newConversations.forEach((newConv) => {
                    const idx = this.allConversations.findIndex(
                        (c) => c.id === newConv.id
                    );
                    if (idx !== -1) {
                        // Only update if changed
                        const updated = this.allConversations[idx];
                        if (
                            updated.updated_at !== newConv.updated_at ||
                            updated.unread !== newConv.unread ||
                            updated.hasDraft !== newConv.hasDraft
                        ) {
                            this.$set(this.allConversations, idx, newConv);
                        }
                    } else {
                        this.allConversations.unshift(newConv);
                    }
                });
                // Sort by updated_at descending to match server order
                this.allConversations.sort(
                    (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
                );
            },
        },
    },
};
</script>

<style scoped>
.chat-search {
    flex: 0;
}

.conversation-scroll {
    flex: 1 1 0;
    flex-direction: column;
    display: flex;
    position: relative;
    overflow-y: auto;
    scrollbar-width: none;
}

.virtual-conversation-scroll {
    scrollbar-width: none;
}

.unread-avatar {
    border: 2px solid #228cbd;
}

.conversation-items {
    flex: 0;
    min-height: unset;
}
</style>
